"use client";

import ProfileForm, {
  ProfileFormConfig,
} from "@amzn/aws-marketing-identity-kit-profile-form";
import { Profile, ProfileInput } from "@amzn/builder-profile-sdk";

export interface ProfileFormProps {
  profile?: ProfileInput & { email: string };
  config?: ProfileFormConfig;
}

const ProfileFormComponent = ({ profile, config }: ProfileFormProps) => {
  return <ProfileForm profile={profile as Profile} config={config} />;
};

export default ProfileFormComponent;
